
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Natureresortinnagpur() {



  const cardData =
  {
    keyword: ' Nature Resort in Nagpur',
    heading:  'Woodland Escape: Nature Resort in Nagpur ',
    headingDescription: 'Woodland Escape Resort is a truly inviting nature resort in Nagpur District, offering a peaceful escape surrounded by lush greenery, open lawns and forest-framed surroundings. Set just a short drive outside the city, the resort allows guests to unwind in comfy cottages, stroll along shaded nature trails, relax on wide grassy areas, and absorb the calm ambiance of the countryside. Whether you are planning a weekend with family, a couple’s retreat or a quiet group getaway, Woodland Escape Resort blends the simplicity of nature with warm hospitality and comfortable amenities — making your stay restorative and memorable.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Nature Resort in Nagpur",
      "description": "Experience the serene beauty of Nagpur with a stay at a Nature Resort. Surrounded by lush greenery, rivers, and hills, guests can enjoy peaceful walks, fresh air, and reconnect with nature in a tranquil environment."
    },
    {
      "name": "Nagpur Eco Nature Resort",
      "description": "Nagpur Eco Nature Resort focuses on sustainable living and eco-friendly accommodations. Guests enjoy organic meals, eco-conscious amenities, and activities such as tree planting, gardening, and guided nature walks."
    },
    {
      "name": "Nagpur Riverside Nature Resort",
      "description": "Located beside scenic rivers, Nagpur Riverside Nature Resort offers riverside walks, fishing, boating, and stunning sunset views. Perfect for couples, families, and nature lovers seeking a peaceful getaway."
    },
    {
      "name": "Nagpur Hill Nature Resort",
      "description": "Nestled on picturesque hills, Nagpur Hill Nature Resort provides breathtaking panoramic views, hiking opportunities, and fresh hill air. Guests can enjoy guided treks, morning yoga, and nature trails."
    },
    {
      "name": "Nagpur Family Nature Resort",
      "description": "Nagpur Family Nature Resort offers activities for all age groups, including outdoor games, nature trails, animal feeding, and interactive workshops. Spacious family-friendly accommodations make it ideal for group outings."
    },
    {
      "name": "Nagpur Adventure Nature Resort",
      "description": "Combine nature with adventure at Nagpur Adventure Nature Resort. Guests can enjoy trekking, cycling, zip-lining, rope courses, and other outdoor adventure activities amidst pristine natural surroundings."
    },
    {
      "name": "Nagpur Luxury Nature Stay",
      "description": "Nagpur Luxury Nature Stay combines comfort with scenic beauty. Enjoy premium cottages, private balconies overlooking forests or rivers, curated farm-to-table meals, and exclusive nature experiences."
    },
    {
      "name": "Nagpur Kids Friendly Nature Resort",
      "description": "Designed for children, this resort includes nature-based play areas, educational workshops, animal interactions, and safe outdoor activities that allow kids to explore and learn about the environment."
    },
    {
      "name": "Nagpur Weekend Nature Resort",
      "description": "Nagpur Weekend Nature Resort is perfect for a short retreat from the city. Guests can enjoy day hikes, riverside picnics, bonfires, cultural activities, and relaxing stays surrounded by greenery."
    },
    {
      "name": "Nagpur Private Nature Resort",
      "description": "Nagpur Private Nature Resort offers exclusive cottages and secluded areas for families, couples, or groups. Guests enjoy privacy, personalized services, and bespoke nature experiences."
    },
    {
      "name": "Nagpur Jungle Nature Resort",
      "description": "Immerse yourself in the jungle at Nagpur Jungle Nature Resort. Spot wildlife, enjoy guided jungle walks, birdwatching, and safari experiences while staying in eco-friendly cottages surrounded by forest."
    },
    {
      "name": "Nagpur Booking Nature Resort",
      "description": "Easily book your stay at Nagpur Booking Nature Resort online. Choose from family, couple, or private cottages and plan a nature-filled retreat with convenience and flexibility."
    },
    {
      "name": "Nagpur One Day Nature Resort",
      "description": "For short trips, Nagpur One Day Nature Resort offers a full-day package including nature walks, guided tours, interactive activities, and local cuisine. Perfect for day outings in the lap of nature."
    },
    {
      "name": "Nagpur Scenic Nature Resort",
      "description": "Nagpur Scenic Nature Resort provides breathtaking views of forests, rivers, and hills. Guests can enjoy photography, leisure walks, and sunrise-sunset experiences amidst natural beauty."
    },
    {
      "name": "Nagpur Outdoor Nature Resort",
      "description": "Nagpur Outdoor Nature Resort specializes in outdoor activities like trekking, cycling, campfires, and adventure sports. Guests can actively engage with nature while enjoying scenic surroundings."
    }
  ],
  "tableData": [
    ["- Nature Resort in Nagpur", "- Nagpur Eco Nature Resort"],
    ["- Nagpur Riverside Nature Resort", "- Nagpur Hill Nature Resort"],
    ["- Nagpur Family Nature Resort", "- Nagpur Adventure Nature Resort"],
    ["- Nagpur Luxury Nature Stay", "- Nagpur Kids Friendly Nature Resort"],
    ["- Nagpur Weekend Nature Resort", "- Nagpur Private Nature Resort"],
    ["- Nagpur Jungle Nature Resort", "- Nagpur Booking Nature Resort"],
    ["- Nagpur One Day Nature Resort", "- Nagpur Scenic Nature Resort"],
    ["- Nagpur Outdoor Nature Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Serene Nature Resort in Nagpur",
    "WhyChoosedescription": "Woodland Escape Resort offers an immersive nature experience in Nagpur, surrounded by lush greenery, forested landscapes, and scenic views. It’s the perfect getaway for families, couples, and groups seeking peace and relaxation in a natural setting."
  },
  {
    "WhyChooseheading": "Tranquil Forest Ambience",
    "WhyChoosedescription": "Nestled amidst dense trees and serene natural surroundings, the resort provides a calm and refreshing atmosphere. Guests can enjoy the sounds of birds, rustling leaves, and gentle breezes while unwinding from city life."
  },
  {
    "WhyChooseheading": "Comfortable Eco-Friendly Accommodation",
    "WhyChoosedescription": "The resort offers well-designed rooms and cottages that blend modern comfort with nature. Guests can enjoy cozy interiors, forest views, and eco-conscious amenities, ensuring a relaxing stay that respects the environment."
  },
  {
    "WhyChooseheading": "Outdoor Activities and Exploration",
    "WhyChoosedescription": "Woodland Escape provides numerous opportunities for nature-based activities such as nature walks, cycling, birdwatching, and pond-side relaxation. Guests can engage with the surroundings while staying active and entertained."
  },
  {
    "WhyChooseheading": "Family and Group Friendly",
    "WhyChoosedescription": "The resort caters to families and groups with spacious areas for games, picnics, and leisure activities. It’s an ideal location for bonding, creating memories, and enjoying quality time together amidst nature."
  },
  {
    "WhyChooseheading": "Fresh Local Cuisine",
    "WhyChoosedescription": "Guests can enjoy freshly prepared local and organic meals, snacks, and beverages. Dining at Woodland Escape combines the joy of delicious food with the pleasure of natural surroundings."
  },
  {
    "WhyChooseheading": "Conveniently Located with Nature’s Privacy",
    "WhyChoosedescription": "Located within Nagpur, Woodland Escape Resort offers easy accessibility while maintaining a secluded, nature-rich environment. Guests can enjoy the perfect balance of convenience and a tranquil natural retreat."
  }
]

































  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a nature resort in Nagpur?",
    answer: "Woodland Escape Resort offers a peaceful escape in Nagpur district surrounded by greenery and nature‑filled ambiance—ideal for guests looking to relax in a natural setting."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur city?",
    answer: "The resort is located within driving distance of Nagpur city, making it accessible for short getaways while still providing a tranquil nature‑retreat."
  },
  {
    question: "What facilities does Woodland Escape Resort offer for a nature‑surrounded stay?",
    answer: "The resort provides nature‑view rooms or cottages, open lawns, walking trails, greenery all around, comfortable stays, and services designed for a stay immersed in nature."
  },
  {
    question: "Is Woodland Escape Resort suitable for families, couples and groups seeking a nature stay?",
    answer: "Yes! The resort is ideal for families, couples or groups wanting a nature‑filled break—safe, scenic, and relaxing with amenities that cater to different guest types."
  },
  {
    question: "Does the resort provide meals and other services for the nature‑retreat stay?",
    answer: "Yes. Woodland Escape Resort offers freshly prepared meals, snacks and beverages and provides services suited for a rejuvenating nature stay in Nagpur district."
  },
  {
    question: "How can we book Woodland Escape Resort for a nature‑surrounded stay in Nagpur district?",
    answer: "You can book by calling or WhatsApp messaging the resort’s reservations team, or by visiting the official website. Advance booking is recommended—especially for weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Rajesh & Family, Nagpur",
    text: "Our stay at Woodland Escape Resort was wonderful! The surrounding greenery, walking trails and tranquil ambiance made it a perfect nature stay near Nagpur."
  },
  {
    name: "Ms. Anjali & Friends, Nagpur",
    text: "We loved our escape at Woodland Escape Resort. The nature‑filled setting and relaxing environment made our weekend special. Highly recommended!"
  }
];
































      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const natureResortSchema = {
  "@context": "https://schema.org",
  "@type": "LodgingBusiness",
  "name": "Nature Resort in Nagpur",
  "image": "https://woodlandescape.com/assets/images/nagpur-nature-resort.jpg",
  "description": "Discover the perfect getaway at our Nature Resort in Nagpur. Enjoy eco-friendly stays, riverside views, hill locations, family-friendly amenities, and adventure activities.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Nagpur",
    "addressRegion": "Maharashtra",
    "addressCountry": "IN"
  },
  "telephone": "+91-XXXXXXXXXX",
  "url": "https://woodlandescape.com/nagpur-nature-resort",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "42",
    "bestRating": "5",
    "worstRating": "1"
  },
  "amenityFeature": [
    {"@type": "LocationFeatureSpecification", "name": "Eco-Friendly", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Family-Friendly", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Adventure Activities", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Riverside View", "value": true},
    {"@type": "LocationFeatureSpecification", "name": "Hill View", "value": true}
  ]
};




  return (
    <div>
<Helmet>
  <title>Nature Resort in Nagpur | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Experience a rejuvenating stay at our Nature Resort in Nagpur. Perfect for families, adventure seekers, and nature lovers, with eco-friendly, riverside, and hill stays." 
  />
  <meta 
    name="keywords" 
    content="Nature Resort in Nagpur, Nagpur Eco Nature Resort, Nagpur Riverside Nature Resort, Nagpur Hill Nature Resort, Nagpur Family Nature Resort, Nagpur Adventure Nature Resort, Nagpur Luxury Nature Stay, Nagpur Kids Friendly Nature Resort, Nagpur Weekend Nature Resort, Nagpur Private Nature Resort, Nagpur Jungle Nature Resort, Nagpur Booking Nature Resort, Nagpur One Day Nature Resort, Nagpur Scenic Nature Resort, Nagpur Outdoor Nature Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(natureResortSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/56.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Natureresortinnagpur;